import React from 'react';
import { cardColors, getTextColor } from './cardColors';

export default function LeftPanel({ cardSelections, hits, payouts, bets, onToggleShowAll, showAllCards, onQuickPick, quickPickLabel, onErase, eraseLabel, totalWin, activePaytable, activeCard }) {
  const cards = Array.from({ length: 20 }, (_, i) => String.fromCharCode(65 + i));

  return (
    <aside className="left-panel">
      <div style={{ marginBottom: "10px", border: "1px solid #fff", borderRadius: "4px", background: "#000", fontWeight: "bold", fontSize: "15px", color: "#fff", textAlign: "center" }}>
        Active Pay Table: <span style={{ color: "yellow" }}>{activePaytable}</span>
      </div>
      <div style={{ marginBottom: '6px', fontWeight: 'bold', fontSize: '24px', color: '#ffd600', textAlign: 'center', letterSpacing: '1px', lineHeight: '24px', height: '24px', overflow: 'hidden', textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000', fontStyle: 'italic' }}>
        CURRENT: {showAllCards ? 'ALL' : activeCard}
      </div>
      <div className="lp-inner">
        <div className="lp-header">
          <div className="lp-col lp-card">Card</div>
          <div className="lp-col lp-bet">Bet</div>
          <div className="lp-col lp-marks">Marked</div>
          <div className="lp-col lp-payout">Hits</div>
          <div className="lp-col lp-hit">Pays</div>
        </div>

        {cards.map(card => {
          const hasBet = bets?.[card] > 0;
          const markedCount = cardSelections?.[card]?.length || 0;
          const hitCount = hits?.[card] || 0;
          const pays = hasBet ? ((payouts?.[card] || 0) * (bets?.[card] || 0)) : 0;
          // yellow if pays=0, red if pays>0
          const rowClass = hasBet ? (pays > 0 ? 'lp-row hit-some' : 'lp-row hit-none') : 'lp-row';
          return (
            <div key={card} className={rowClass}>
              <div 
                className="lp-col lp-card" 
                style={{
                  backgroundColor: cardColors[card],
                  color: getTextColor(cardColors[card]),
                  fontWeight: 'bold'
                }}
              >{card}</div>
              <div className="lp-col lp-bet">{hasBet ? bets[card] : '-'}</div>
              <div className="lp-col lp-marks">{hasBet ? markedCount : '-'}</div>
              <div className="lp-col lp-payout">{hasBet ? hitCount : '-'}</div>
              <div className="lp-col lp-hit">{hasBet ? pays : '-'}</div>
            </div>
          );
        })}
      </div>

      <div className="lp-controls">
        <div className="lp-controls">
          <div className="lp-controls-row" style={{ justifyContent: 'center' }}>
            <button onClick={onToggleShowAll} className="btn btn-gray left-panel-btn" style={{ visibility: showAllCards ? 'hidden' : 'visible', width: '206px', height: '26px', margin: '0 0px' }}>
              <span style={{ color: '#007bff', fontSize: '14px', fontWeight: 'bold', whiteSpace: 'normal', wordBreak: 'break-word' }}>Show All Cards</span>
            </button>
          </div>
          <div className="lp-controls-row" style={{ justifyContent: 'center', marginTop: '0px' }}>
            <button onClick={onQuickPick} className="btn btn-gray left-panel-btn" style={{ width: '100px', minHeight: '26px', height: 'auto', margin: '0 2px' }}>
              <span style={{ color: '#007bff', fontSize: '14px', fontWeight: 'bold', whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'center' }}>{quickPickLabel}</span>
            </button>
            <button onClick={onErase} className="btn btn-gray left-panel-btn" style={{ width: '100px', minHeight: '26px', height: 'auto', margin: '0 2px' }}>
              <span style={{ color: '#007bff', fontSize: '14px', fontWeight: 'bold', whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'center' }}>{eraseLabel}</span>
            </button>
          </div>
        </div>
      </div>

      {/* Total Credits Bet label */}
      <div className="lp-win-display" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4px', marginBottom: '2px' }}>
        <span className="lp-win-label" style={{ flex: 1, textAlign: 'left' }}>Total Bet</span>
        <span className="lp-win-value" style={{ flex: 1, textAlign: 'right' }}>{Object.values(bets).reduce((sum, bet) => sum + bet, 0)}</span>
      </div>

      {/* Credits Won label, shifted down */}
      <div className="lp-win-display" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '2px', marginBottom: '2px' }}>
        <span className="lp-win-label" style={{ flex: 1, textAlign: 'left' }}>Credits Won</span>
        <span className="lp-win-value" style={{ flex: 1, textAlign: 'right' }}>{totalWin}</span>
      </div>
    </aside>
  );
}
